(function () {
  const bar = document.getElementById('sticky-price-bar');
  const atcBtn = document.getElementById('sticky-bar-atc');
  const stickyPrice = document.getElementById('sticky-bar-price');

  if (!bar) return;

  const priceBlock = document.querySelector('.price-item--regular');

  // Afficher/masquer selon la position du prix au scroll
   // Toujours visible sur le template "reparation"
  const isReparation = document.body.classList.contains('template-reparation')
    || window.location.pathname.includes('reparation');

  function onScroll() {
    if (isReparation) {
      bar.style.display = 'block';
      return;
    }
    if (!priceBlock) {
      bar.style.display = 'block';
      return;
    }
    const rect = priceBlock.getBoundingClientRect();
    bar.style.display = rect.bottom < 0 ? 'block' : 'none';
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
//Seb
// Masquer la barre quand le tiroir panier est ouvert
document.addEventListener('cart:open', function () {
  bar.style.display = 'none';
});
document.addEventListener('cart:close', function () {
  onScroll();
});

// Fallback : observer l'attribut aria-expanded ou la classe active du tiroir panier
const cartDrawer = document.querySelector('cart-drawer, #CartDrawer, [id*="cart-drawer"]');
if (cartDrawer) {
  const observer = new MutationObserver(function () {
    const isOpen = cartDrawer.classList.contains('is-open')
      || cartDrawer.classList.contains('active')
      || cartDrawer.getAttribute('aria-hidden') === 'false'
      || cartDrawer.hasAttribute('open');
    bar.style.display = isOpen ? 'none' : '';
    if (!isOpen) onScroll();
  });
  observer.observe(cartDrawer, { attributes: true, attributeFilter: ['class', 'aria-hidden', 'open'] });
}


  // Clic sur "Ajouter au panier"
  atcBtn.addEventListener('click', function () {
    const mainAtcBtn = document.querySelector('[name="add"]')
      || document.querySelector('.product-form__submit')
      || document.querySelector('button[type="submit"]');
    if (mainAtcBtn) mainAtcBtn.click();
  });

   // Synchronisation variante - multi-événements
   function updatePrice() {
    const priceEl = document.querySelector('.price-item--regular');
    const variantEl = document.querySelector('.product-variant-id');
    const variantNameEl = document.getElementById('sticky-bar-variant');

    if (priceEl && stickyPrice) {
      stickyPrice.textContent = priceEl.textContent.trim();
    }

    // Lire le nom de la variante sélectionnée
    if (variantNameEl) {
      const selectedOption = document.querySelector('input[name="id"]:checked')
        || document.querySelector('.product-variant-id');
      const label = document.querySelector('input[type="radio"]:checked + label, .selected-variant-label');
      if (label) {
        variantNameEl.textContent = label.textContent.trim();
      }
    }
  }


// Écouter tous les événements possibles
document.addEventListener('variant:change', updatePrice);
document.addEventListener('variantChange', updatePrice);
document.addEventListener('change', function(e) {
  if (e.target.name === 'id' || e.target.closest('[data-variant-select]')) {
    setTimeout(updatePrice, 100);
  }
});

// Correctif iOS (Safari 26.3 et +)
if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
  document.addEventListener('touchstart', function(e) {
    const variantBtn = e.target.closest('[data-variant-select], .variant-input, .product-form__input label');
    if (variantBtn) {
      setTimeout(updatePrice, 200);
    }
  }, { passive: true });

  document.addEventListener('touchend', function(e) {
    const variantBtn = e.target.closest('[data-variant-select], .variant-input, .product-form__input label');
    if (variantBtn) {
      setTimeout(updatePrice, 150);
    }
  }, { passive: true });
}


})();
